import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface NavbarProps {
  onToggleSidebar: () => void;
}

/** Slightly above original sizes — comfortable at 100% zoom without feeling oversized */
const FAO_HEIGHT_PX = 44;
const TITLE_HEIGHT_PX = 54;

const Navbar: React.FC<NavbarProps> = ({ onToggleSidebar: _onToggleSidebar }) => {
  const { isAuthenticated, user, logout } = useAuthStore();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="w-screen">
      <div className="relative text-[#545454] bg-[#F7F8F9] flex justify-between items-center py-2.5 pl-4 pr-6 z-50 shadow-md min-h-[5rem] overflow-visible">
        {/* FAO logo */}
        <div className="flex-shrink-0 z-10">
          <Link to="/" className="flex items-center" aria-label="Home">
            <img
              src={`${process.env.PUBLIC_URL}/fao-logo-black-3lines-en.svg`}
              alt="FAO"
              className="w-auto object-contain object-left"
              style={{ height: FAO_HEIGHT_PX, minHeight: FAO_HEIGHT_PX }}
            />
          </Link>
        </div>

        {/* Centered title image */}
        <h1
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none z-20 m-0"
        >
          <img
            src={`${process.env.PUBLIC_URL}/title.png`}
            alt="EuFMD Nexus"
            className="w-auto object-contain block"
            style={{ height: TITLE_HEIGHT_PX }}
          />
        </h1>

        {/* Right actions */}
        <div className="flex justify-end items-center flex-shrink-0 z-10 min-w-[5rem]">
          {!isAuthenticated ? (
            <Link
              className="bg-[#15736d] px-5 py-2.5 text-base whitespace-nowrap font-semibold text-white rounded-lg hover:bg-[#438f8a] focus:bg-[#438f8a] focus:outline-none focus:shadow-outline"
              to="/login"
            >
              Log In
            </Link>
          ) : (
            <button
              className="px-4 py-2.5 text-base font-semibold text-[#545454] bg-transparent rounded-lg hover:text-[#15736d] focus:text-[#15736d] hover:bg-[#F2F2F2] focus:bg-[#F2F2F2] focus:outline-none focus:shadow-outline"
              onClick={handleLogout}
            >
              <div className="flex flex-row items-center">
                <p>{user?.email || 'User'}</p>
                <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </div>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
